module.exports = __webpack_public_path__ + "img/Cross_Symbol.6744dee2.svg";